import Login from '@/views/login'
import Home from '@/views/layout/home'
import membersList from '@/views/members/membersList'
import membersRecord from '@/views/members/membersRecord'
import projectList from '@/views/project/projectList'
import projectDes from '@/views/project/projectDes'
import mutualHelpList from '@/views/mutualHelp/mutualHelpList'
import manager from '@/views/manager/manager'
import dealFlow from '@/views/remuneration/dealFlow'
import settlement from '@/views/remuneration/settlement'
import summary from '@/views/remuneration/summary'

const routes = [
  {
    path: '/login',
    name: '登录',
    component: Login,
  },
  {
    path: '/',
    redirect: '/membersList',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/membersList',
        name: 'membersList',
        component: membersList,
      },
      {
        path: '/membersRecord',
        name: 'membersRecord',
        component: membersRecord,
      },
      {
        path: '/projectList',
        name: 'projectList',
        component: projectList,
      },
      {
        path: '/projectDes',
        name: 'projectDes',
        component: projectDes,
      },
      {
        path: '/mutualHelpList',
        name: 'mutualHelpList',
        component: mutualHelpList,
      },
      {
        path: '/manager',
        name: 'manager',
        component: manager,
      },
      {
        path: '/remuneration/dealFlow',
        name: 'dealFlow',
        component: dealFlow,
      },
      {
        path: '/remuneration/settlement',
        name: 'settlement',
        component: settlement,
      },
      {
        path: '/remuneration/summary',
        name: 'summary',
        component: summary,
      },
    ],
  },
]

export default routes
